import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { ProductWrapperStatic } from "./ProductWrapperStatic";
import { QuoteClientInfoStatic } from "./QuoteClientInfoStatic";
import { QuoteInstructionStatic } from "./QuoteInstructionStatic";
import { SecondClientDetailsStatic } from "./SecondClientDetailsStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const QuoteInstructionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const QuoteInstructionStore: QuoteInstructionStatic = new QuoteInstructionStatic();

export const QuoteClientInfoDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const QuoteClientInfoStore: QuoteClientInfoStatic = new QuoteClientInfoStatic();

export const ProductWrapperDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ProductWrapperStore: ProductWrapperStatic = new ProductWrapperStatic();

export const SecondClientDetailsDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const SecondClientDetailsStore: SecondClientDetailsStatic = new SecondClientDetailsStatic();
